"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVisitorId = exports.createSessionId = void 0;
var Helper = __importStar(require("firefly-utilities-helper-ts"));
var firefly_constants_1 = __importDefault(require("./constants/firefly-constants"));
var Utilities = __importStar(require("./utilities"));
var sapphire_constants_1 = __importDefault(require("./constants/sapphire-constants"));
function create48BitTimeByteArray() {
    return Utilities.getByteArrayFromInteger(Helper.getSystemDate().getMilliseconds(), 6);
}
function create64BitRandomByteArray() {
    var randomValue;
    randomValue = Helper.getRandomNumber(0, firefly_constants_1.default.INTEGER_MAX);
    var sixteenBitRandomValue = Utilities.getByteArrayFromInteger(randomValue, 2);
    randomValue = Helper.getRandomNumber(0, firefly_constants_1.default.INTEGER_MAX);
    var fortyEightBitRandomValue = Utilities.getByteArrayFromInteger(randomValue, 6);
    return sixteenBitRandomValue.concat(fortyEightBitRandomValue);
}
function getHexStringFromByte(byte) {
    var hexCharArray, hexString;
    if (Helper.isNumber(byte)) {
        hexCharArray = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F'];
        hexString = hexCharArray[(byte >> 4) & 0x0f] + hexCharArray[byte & 0x0f];
    }
    return hexString;
}
function getHexStringFromByteArray(byteArray) {
    var hexString = "";
    if (Helper.isArray(byteArray)) {
        hexString = byteArray.map(getHexStringFromByte).join("");
    }
    return hexString;
}
function createSessionId() {
    return Utilities.createHashValue();
}
exports.createSessionId = createSessionId;
function createVisitorId(sourceValue) {
    var decorator = firefly_constants_1.default.DEC_VISITOR_ID;
    var source = (Helper.isNumber(sourceValue)) ? sourceValue : sapphire_constants_1.default.SOURCE_NA;
    var timeByteArray = create48BitTimeByteArray();
    var randomByteArray = create64BitRandomByteArray();
    var byteArray = timeByteArray.concat([decorator, source]).concat(randomByteArray);
    return getHexStringFromByteArray(byteArray);
}
exports.createVisitorId = createVisitorId;
